const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 3,
    // marginTop: 90,
    '&$noMargin': {
      margin: 0
    },

    '& *[class*="MUIDataTableToolbar-titleText"]': {
      color: theme.palette.primary.main,
    },
    
    '& .btn-toolbar:hover': {
      color: theme.palette.primary.main,
    }
  }),
  title: {
    // marginBottom: theme.spacing.unit * 4,
    color: theme.palette.primary.main,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
    textTransform: 'capitalize',
    fontSize: 22,
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: 40,
      borderBottom: `4px solid ${theme.palette.primary.main}`
    }
  },
  description: {
    maxWidth: 960,
    fontSize: 16,
  },
  content: {
    marginTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit,
    paddingTop: theme.spacing.unit,
    backgroundColor: theme.palette.background.paper,
  },
  whiteBg: {
    backgroundColor: 'transparent',
    margin: 0,
  },
  noMargin: {},
  colorMode: {
    backgroundColor: theme.palette.primary.main,
    '& $title': {
      color: theme.palette.grey[100],
      '&:after': {
        borderBottom: `5px solid ${theme.palette.primary.light}`
      }
    },
    '& $description': {
      color: theme.palette.grey[100],
    }
  },
  overflowX: {
    width: '100%',
    overflowX: 'auto',
  },
  displayNone: {
    display: 'none'
  }
});

export default styles;
